import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_SERVICE } from '@/pages/settings/org/components/integrations/hris_onboarding/api/api';

const getHrisTools = async (_payload, { extra: { http } }) => {
  try {
    const result = await API_SERVICE.getHrisTools();
    return result;
  } catch (e) {}
};

export const fetchHrisTools = createAsyncThunk(
  'integrations/fetch/all',
  getHrisTools,
  {
    condition: (_userId, { getState }) => {
      const { integrations } = getState();
      return integrations?.data?.length === 0;
    },
  }
);
